import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class QuillHelper {
    public static normalize(quillValue: string): string {
        let normalizedValue = quillValue

            .replace(/&(nbsp|ensp|emsp|thinsp);/gi, ' ') // replace common space entities    
            .replace(/[\u00A0\u2000-\u200B\u202F\uFEFF]/g, ' ') // replace unicode space-likes that might already be present
            .replace(/ {2,}/g, ' ') // collapse multiple spaces 
            .trim();;

        return normalizedValue;
    }
}